<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Создать вопрос</strong>
                </CCardHeader>
                <CCardBody>
                    <SurveyQuestionUpsertForm
                        @success="$router.push(`/surveys/${$route.params.id}/questions`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import SurveyQuestionUpsertForm from '@/components/surveys/SurveyQuestionUpsertForm';

    export default {
        name: 'SurveyCreate',

        components: {
            SurveyQuestionUpsertForm
        },
    };
</script>
